/* lib/text_section_cx.js */

/* Copyright 2020 - present Tikkl, Inc. */

/*
modification history
--------------------
01a,30may25,mno  created.
*/

import classNames from 'classnames';
import tinyColor from 'tinycolor2';

const textSectionCx = (section, cx) => (
  classNames(
    cx,
    'text-section',
    {
      column: section.column,
      'has-text-centered': section.align === 'center',
      'has-text-justified': section.align === 'justify',
      'has-text-left': section.align === 'left',
      'has-text-right': section.align === 'right',
      'is-medium': section.spacing === 'medium',
      'is-large': section.spacing === 'large',
      'has-dark-bg': tinyColor(section.backgroundColor || '#fff').isDark(),
    }
  )
);

export default textSectionCx;
